export const qimoArr = [
  {
    label: 'Right side cover of automobile gearbox',
    src: './assets/product-1-1.png'
  },
  {
    label: 'Automobile gearbox housing',
    src: './assets/product-1-2.png'
  },
  {
    label: 'Automotive air conditioning distribution body',
    src: './assets/product-1-3.png'
  },
  {
    label: 'Car knuckle',
    src: './assets/product-1-4.png'
  }
];

export const tongxunArr = [
  {
    label: 'Wireless communication case',
    src: './assets/product-2-1.png'
  },
  {
    label: 'Power electrical wire clip',
    src: './assets/product-2-2.png'
  },
  {
    label: 'Automatic control of the servo cooling bracket',
    src: './assets/product-2-3.png'
  },
  {
    label: 'Aluminium die-casting filter',
    src: './assets/product-2-4.png'
  }
];

export const diandongArr = [
  {
    label: 'Automatic hydraulic station drives the pump',
    src: './assets/product-3-1.png'
  },
  {
    label: 'Accumulation type motor housing',
    src: './assets/product-3-2.png'
  },
  {
    label: 'Lawn mower rack',
    src: './assets/product-3-3.png'
  },
  {
    label: 'Motor link',
    src: './assets/product-3-4.png'
  }
];

export const dengjuArr = [
  {
    label: 'The LED lamp',
    src: './assets/product-4-1.png'
  },
  {
    label: 'LED lamp radiator.',
    src: './assets/product-4-2.png'
  },
  {
    label: 'LED street lamp shell',
    src: './assets/product-4-3.png'
  },
  {
    label: '',
    src: './assets/product-4-4.png'
  }
];

export const jixieArr = [
  {
    label: 'Automatic hydraulic station drives the pump valve body',
    src: './assets/product-5-1.png'
  },
  {
    label: 'Aluminum die-cast top cover for automobile engines',
    src: './assets/product-5-2.png'
  },
  {
    label: 'Automotive gasoline diesel filter pump body',
    src: './assets/product-5-3.png'
  },
  {
    label: 'Connector for automotive air conditioning compressor',
    src: './assets/product-5-4.png'
  }
];

export const biaomianArr = [
  {
    label: 'Towel rack trim ring plated with bright chrome',
    src: './assets/product-6-1.png'
  },
  {
    label: 'Card reader card inserter cover round sand plated chrome pearl chrome',
    src: './assets/product-6-2.png'
  },
  {
    label: 'The signal distribution box of the communication base station is powdered',
    src: './assets/product-6-3.png'
  },
  {
    label: 'Aluminum alloy zinc alloy plate frame plated with black nickel',
    src: './assets/product-6-4.png'
  }
];

export const mujuArr = [
  {
    label: 'Die casting die for VVT engine aluminum alloy top cover',
    src: './assets/product-7-1.png'
  },
  {
    label: 'Die casting die for VVT engine aluminum alloy top cover.',
    src: './assets/product-7-2.png'
  },
  {
    label: 'Radiator aluminum die casting mold.',
    src: './assets/product-7-3.png'
  },
  {
    label: 'Communication box body aluminum alloy die-casting mold moving mold',
    src: './assets/product-7-4.png'
  }
];
